import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import useMediaQuery from "@mui/material/useMediaQuery";
import { NotoSansJp } from "./TextStyle";

const privacySections = [
  {
    title: "第1条",
    body: [
      "「個人情報」とは、個人情報の保護に関する法律（平成15年法律第57号、個人情報の保護に関する法律、以下「個人情報保護法」といいます。）にいう「個人情報」を指し、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別できるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含む。）又は個人識別符号が含まれるものを指します。",
    ],
  },
  {
    title: "第2条",
    body: [
      "弊社は、下の目的に必要な範囲で、ご本人の個⼈情報を取得し、取得した情報を利用します。以下の⽬的の範囲を超えて個⼈情報を利⽤する場合には、事前に適切な⽅法でご本人からの同意を得ます。",
    ],
    subSections: [
      {
        subtitle: "（1）本サービス利用者の個人情報等の利用目的",
        items: [
          "1.弊社が提供するサービス（以下「本サービス」といいます。）提供のため",
          "2.本サービス及び新規サービスの改善及び開発のため",
          "3.本サービスのご案内（電子メール、チラシ、その他のダイレクトメールの送付を含む。）のため",
          "4.メンテナンス、重要なお知らせなど必要に応じたご連絡のため",
          "5.お問い合わせ対応のため",
          "6.本サービスの利用状況を利用者にご報告するため",
          "7.本サービスに関するアンケート、モニター、取材等の実施のため",
          "8.閲覧履歴や購買履歴等の情報を特定の個人を識別できない形式に加工して、本サービスの利用状況に関する統計データを作成し、その結果を本サービスの改良・開発や広告の配信に利用するため",
          "9.本サービスに係る利用規約で禁じられている行為、またはそのおそれのある行為を防止、調査し、それらに基づき適切に対処するため",
        ],
      },
      {
        subtitle: "（2）弊社への採用応募者の個人情報等の利用目的",
        items: [
          "1.採用条件の検討・決定、採否の検討・決定、応募履歴の確認、応募者の職務経歴・背景の調査を遂行するため",
          "2.問い合わせ対応、事務連絡、その他採用選考に必要な手続きを遂行するため",
          "3.採用決定後の入社に関する必要事項の案内、その他これに必要な手続きを遂行するため",
          "4.入社後の人事労務管理のため",
          "5.将来の採用計画のために統計的に利用する等、採用活動に付随する目的のため",
        ],
      },
    ],
  },
  {
    title: "第3条",
    body: [
      "個人情報の管理を厳重に行い、次に掲げる場合を除き、ご本人の同意がない限り、第三者に対しデータを開示・提供しません。",
    ],
    subSections: [
      {
        subtitle: "",
        items: [
          "1.人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき",
          "2.公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき",
          "3.国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき",
          "4.業務を円滑に遂行するため、利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託する場合",
          "5.合併その他の事由による事業の承継に伴って個人情報が提供される場合",
          "6.個人情報を特定の者との間で共同して利用する場合であって、その旨並びに共同して利用される個人情報の項目、共同して利用する者の範囲、利用する者の利用目的並びに当該個人情報の管理について責任を有する者の氏名又は名称及び住所並びに法人にあっては、その代表者（法人でない団体で代表者又は管理人の定めのあるものにあっては、その代表者又は管理人）の氏名について、あらかじめ本人に通知し、又は本人が容易に知り得る状態に置いた場合",
          "7.その他法令に基づき許容される場合",
        ],
      },
    ],
  },
  {
    title: "第4条",
    body: [
      "弊社は、個人関連情報（Cookie、IPアドレス、閲覧・購入履歴、位置情報、等のうち特定の個人を識別できないもの）を第三者に提供することがあります。",
      "上記提供の際に、弊社において、当該第三者が、上記個人関連情報を利用者ご本人が識別される情報と突合して、個人データ（個人情報保護法に定義されるも）として取得することが想定される場合、弊社は個人情報保護法上求められる義務を履行した上で上記提供を行います。",
      "利用者は、本プライバシーポリシーへの同意をもって、上記第三者が利用者の個人関連情報を個人データとして取得することについてもご同意いただいたこととなりますので、ご留意ください。",
    ],
  },
  {
    title: "第5条",
    body: [
      "弊社は、利用目的の達成に必要な範囲内において、個人情報の取扱いの全部又は一部を委託する場合があります。",
      "この場合、弊社は、委託先としての適格性を十分審査するとともに、契約にあたって守秘義務に関する事項、安全管理措置、秘密保持、再委託の条件その他の個人情報の取扱いに関する事項について適正に定め、委託先に対する必要かつ適切な監督を行います。",
    ],
  },
  {
    title: "第6条",
    body: [
      "弊社は、個人情報の正確性を保ち、これを安全に管理します。また、個人情報の紛失、破壊、改ざん及び漏えいなどを防止するため、下記の安全管理措置を実施しています。",
    ],
    subSections: [
      {
        subtitle: "",
        items: [
          "1.個人情報に関するセキュリティマネジメントシステムの確立と継続的な改善を実現するため、定められた手順を用いて個人情報のリスクを明らかにし、適切なリスク対応を実施する。",
          "2.個人情報に関するセキュリティに対する役割及び責任を明確に定め、個人情報を適切に管理する。",
          "3.個人情報に関するセキュリティを維持する責任を自覚させるために、経営者・従業員及び関係者全てに、教育・啓蒙活動を実施する。",
          "4.個人情報に関するセキュリティマネジメントシステムが実施されていることを監視・記録し、個人情報に関するセキュリティ目的の設定とその達成、定期的な内部監査・マネジメントレビューによって、運用の確実性を高め、継続的な改善を図る。",
          "5.万一、個人情報に関するセキュリティ上の問題が発生した場合、直ちに、原因を究明しその被害を最小限にとどめると共に、事業継続性を確保するよう努力する。",
          "6.個人情報及びその取扱について、法令やその他の社会規範、顧客との契約を遵守する。",
        ],
      },
    ],
  },
  {
    title: "第7条",
    body: [
      "弊社は、ご本人から個人情報の開示（個人データを第三者に提供し又は提供を受ける場合にはその記録を含むものとし、以下同様とします。）、訂正、削除、消去、及び利用停止等を請求を求められたときは、ご本人に対し、遅滞なくこれを開示します。",
      "但し、ご本人又は第三者の生命、身体、財産その他の権利利益を害するおそれがある場合または弊社の業務に支障がある場合、その他法令に違反することとなる場合については、その全部又は一部をお断りすることがあります。",
    ],
  },
  {
    title: "第8条",
    body: [
      "弊社は、本プライバシーポリシーの内容を適宜見直し、その改善に努めます。また、本ポリシーの内容は、法令その他本プライバシーポリシーに別段の定めのある事項を除いて、適宜変更することがあり、変更後のプライバシーポリシーは、弊社所定の方法により、利用者に通知し、又は当サービスに掲載したときから効力を生じます。",
    ],
  },
  {
    title: "第9条",
    body: [
      "弊社は、本サービスのアクセス及び利用状況の分析、広告配信、並びに当サービスの利便性向上のために、本サービスにアクセスしたご本人のデバイスに保存されるファイル及びこれに類似する技術（以下「Cookie等」といいます。）を取得することがあります。ご本人は、自らの責任において、ウェブブラウザの設定を変更することにより、Cookie等の取得を制限することができます。",
      "弊社は、ご本人が本サービスにおいて個人情報を入力若しくは登録した場合、又は弊社から送付されたメール又はこれに類するメッセージに記載されたURLから当サービスにアクセスした場合、Cookie等とご本人の個人情報を関連付けることがあります。",
      "その場合、弊社はご本人の個人情報と関連付けたCookie等がご本人の個人情報であることに鑑み、当該Cookie等を本プライバシーポリシーの定めに従って管理します。",
    ],
  },
  {
    title: "第10条",
    body: [
      "本プライバシーポリシー又は弊社の個人情報等の取扱に関してのお問合わせ・苦情等はこちらまでご連絡ください。",
    ],
  },
];

const Privacypolicy = () => {
  const isSmartphone = useMediaQuery("(max-width:767px)");

  return (
    <Box sx={{ width: "100vw" }}>
      <Grid
        container
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box sx={{ width: "100%", mt: "50px", p: "0 7%" }}>
          <Typography
            sx={{
              color: "#EDE52E", // 明るい黄色
              fontSize: isSmartphone ? "20px" : "35px",
              fontWeight: "bold",
              pt: "50px",
              mb: "20px",
              textAlign: "center",
            }}
          >
            プライバシーポリシー
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#333333",
            }}
          >
            <HomeIcon fontSize="small" sx={{ mr: 1 }} />
            <Typography sx={{ fontSize: "14px", mx: 1 }}>{">"}</Typography>
            <Typography
              sx={{
                color: "#333333",
                fontWeight: 500,
                fontSize: isSmartphone ? "14px" : "16px",
              }}
            >
              プライバシーポリシー
            </Typography>
          </Box>
        </Box>
        <Box sx={{ width: "100%", mt: isSmartphone ? "50px" : "120px", mb: isSmartphone ? "50px" : "120px", p: "0 7%" }}>
          <Box sx={{ maxWidth: "1000px", mx: "auto", position: "relative" }}>
            <Typography
              sx={{
                color: "#333",
                fontSize: isSmartphone ? "14px" : "16px",
                fontWeight: 500,
                mb: "36px",
                ...NotoSansJp
              }}
            >
              弊社は、下記の方針に基づき個人情報の保護に努め、これを遵守するとともに、全ての個人情報をより安全かつ適切に取り扱うことを宣言します。
              弊社に個人情報を提供するにあたっては、下記の内容についてご同意のうえ、ご提供いただきますようお願いします。
            </Typography>
            {privacySections.map((section, index) => (
              <Box key={index} sx={{ mb: 5 }}>
                <Typography
                  sx={{
                    color: "#333",
                    fontSize: "18px",
                    fontWeight: 600,
                    mb: "8px",
                    ...NotoSansJp
                  }}
                >
                  {section.title}
                </Typography>
                <Box sx={{ borderBottom: "1px solid #E0EDF4", mb: 2 }} />
                {section.body.map((text, i) => (
                  <Typography
                    key={i}
                    sx={{
                      fontSize: isSmartphone ? "14px" : "16px",
                      fontWeight: 500,
                      mb: 2,
                      color: "#333",
                      ...NotoSansJp
                    }}
                  >
                    {text}
                  </Typography>
                ))}

                {section.subSections?.map((sub, subIndex) => (
                  <Box key={subIndex} sx={{ mb: 3 }}>
                    <Typography
                      sx={{
                        fontSize: "15px",
                        fontWeight: 600,
                        mb: 1,
                        p: "5px 0",
                        color: "#333",
                        ...NotoSansJp
                      }}
                    >
                      {sub.subtitle}
                    </Typography>
                    <Box>
                      {sub.items.map((item, itemIndex) => (
                        <Typography
                          key={itemIndex}
                          sx={{
                            fontSize: isSmartphone ? "12px" : "14px",
                            fontWeight: 500,
                            color: "#333",
                            ...NotoSansJp
                          }}
                        >
                          {item}
                        </Typography>
                      ))}
                    </Box>
                  </Box>
                ))}
              </Box>
            ))}
            <Typography
              sx={{
                color: "#333",
                fontSize: "14px",
                fontWeight: 500,
                mb: "10px",
                ...NotoSansJp
              }}
            >
              附則 2022年4月1日制定
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Box>
  );
};

export default Privacypolicy;
